export enum MenuButtonSize {
  XXS = "16",
  XS = "24",
  SMALL = "32",
  MEDIUM = "40",
  LARGE = "48"
}

export enum MenuButtonComponentPosition {
  START = "start",
  END = "end"
}
